import React, { useState, useEffect } from 'react';
import API from '../../constants/config';
import LDFAgreement from './LDFAgreement';

const CommissionSale = () => {
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [agents, setAgents] = useState([]);
    const [bikes, setBikes] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [selectedBike, setSelectedBike] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const resetForm = () => {
    setStep(1);
    setAgents([]);
    setBikes([]);
    setCustomers([]);
    setSelectedAgent(null);
    setSelectedBike(null);
    setSelectedCustomer(null);
    setDealAmount('');
    setCommInput('');
    setShowPrint(false);
};
    // Form States
    const [dealAmount, setDealAmount] = useState('');
    const [commInput, setCommInput] = useState('');

    const [showPrint, setShowPrint] = useState(false);

    // Search Functions
    const handleAgentSearch = async (q) => { if (q.length > 2) { const res = await API.get(`/v1/commision/search-agents?q=${q}`); setAgents(res.data.data); } };
    const handleCustomerSearch = async (q) => { if (q.length > 2) { const res = await API.get(`/v1/commision/search-customers?q=${q}`); setCustomers(res.data.data); } };

    const handleSelectAgent = async (agent) => {
        setSelectedAgent(agent);
        const res = await API.get(`/v1/commision/agent-bikes/${agent.id}`);
        setBikes(res.data.data);
        setStep(2);
    };

    const handleFinalSubmit = async () => {
        if (!selectedCustomer || !dealAmount) return alert("Please complete all details!");
        setLoading(true);
        try {
            const res = await API.post('/v1/commision/process-sale', {
                customer_id: selectedCustomer.id,
                agent_id: selectedAgent.id,
                agent_bike_id: selectedBike.id,
                agent_demand_price: selectedBike.demand_price,
                agent_commission: commInput || 0,
                deal_amount: dealAmount,
                payment_method: 'Cash'
            });
            if (res.data.success) setShowPrint(true);
        } catch (err) { alert(err.response?.data?.message || "Error saving sale"); }
        finally { setLoading(false); }
    };

    return (
        <div style={styles.container}>
            {/* Step Wizard */}
            <div style={styles.stepper}>
                <div style={step >= 1 ? styles.activeStep : styles.step}>1. Agent</div>
                <div style={step >= 2 ? styles.activeStep : styles.step}>2. Bike</div>
                <div style={step >= 3 ? styles.activeStep : styles.step}>3. Sale Confirmation</div>
            </div>

            <div style={styles.mainCard}>
                {step === 1 && (
                    <div style={{animation: 'fadeIn 0.5s'}}>
                        <h3>🕵️ Search Agent</h3>
                        <input style={styles.input} placeholder="Enter Name/CNIC..." onChange={(e) => handleAgentSearch(e.target.value)} />
                        <div style={styles.list}>
                            {agents.map(a => <div key={a.id} onClick={() => handleSelectAgent(a)} style={styles.listItem}><b>{a.full_name}</b> ({a.cnic})</div>)}
                        </div>
                    </div>
                )}

                {step === 2 && (
                    <div style={{animation: 'fadeIn 0.5s'}}>
                        <div style={{display:'flex', justifyContent:'space-between'}}><h3>🏍️ Select Bike</h3><button onClick={()=>setStep(1)} style={styles.backBtn}>Back</button></div>
                        <div style={styles.grid}>
                            {bikes.map(b => (
                                <div key={b.id} onClick={() => {setSelectedBike(b); setStep(3);}} style={styles.bikeCard}>
                                    <h4>{b.model_name}</h4><p>{b.registration_number}</p>
                                    <p style={{color:'green'}}>Agent Demand: {b.demand_price}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {step === 3 && (
                    <div style={{
                        display: 'grid', 
                        gridTemplateColumns: !selectedCustomer ? '1fr 1fr' : '1fr', 
                        gap: '30px', 
                        animation: 'fadeIn 0.5s'
                    }}>
                        {/* LEFT COL: Only shows if NO customer is selected */}
                        {!selectedCustomer && (
                            <div style={styles.colLeft}>
                                <h4>👤 Select Customer</h4>
                                <input style={styles.input} placeholder="Search Customer..." onChange={(e) => handleCustomerSearch(e.target.value)} />
                                <div style={styles.list}>
                                    {customers.map(c => (
                                        <div key={c.id} onClick={() => setSelectedCustomer(c)} style={styles.listItem}>
                                            {c.full_name} ({c.phone})
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* RIGHT COL / FULL WIDTH: Shows details when selected */}
                        <div style={styles.colRight}>
                            {selectedCustomer ? (
                                <div style={styles.detailBox}>
                                    <div style={{display:'flex', justifyContent:'space-between', borderBottom:'1px solid #ddd', marginBottom:'10px'}}>
                                        <h4>Customer Details</h4>
                                        <button onClick={() => setSelectedCustomer(null)} style={{background:'none', border:'none', color:'#2563eb', cursor:'pointer'}}>Edit / Change</button>
                                    </div>
                                    <p><b>Name:</b> {selectedCustomer.full_name}</p>
                                    <p><b>Phone:</b> {selectedCustomer.phone}</p>
                                    <p><b>CNIC:</b> {selectedCustomer.cnic}</p>
                                </div>
                            ) : (
                                <div style={styles.warnBox}>Please select a customer from the left list</div>
                            )}

                            {/* Always show pricing if we have a bike */}
                            <div style={styles.calcBox}>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <h4>💰 Deal Summary</h4>
                                    <button onClick={()=>setStep(2)} style={styles.backBtn}>Change Bike</button>
                                </div>
                                <div style={styles.row}><span>Agent Demand:</span> <b>{selectedBike?.demand_price}</b></div>
                                <div style={styles.row}>
                                    <span>Deal Amount:</span> 
                                    <input type="number" style={styles.smallInput} placeholder="0.00" value={dealAmount} onChange={(e)=>setDealAmount(e.target.value)} />
                                </div>
                                <div style={styles.row}>
                                    <span>Dealer Commission:</span> 
                                    <input type="number" style={styles.smallInput} placeholder="Profit" value={commInput} onChange={(e)=>setCommInput(e.target.value)} />
                                </div>
                                <button onClick={handleFinalSubmit} disabled={loading} style={styles.submitBtn}>
                                    {loading ? "Saving..." : "CONFIRM DEAL & PRINT"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal Logic Fix */}
            {showPrint && (
                <LDFAgreement 
                    agent={selectedAgent} 
                    customer={selectedCustomer} 
                    bike={selectedBike} 
                    saleData={{total_price: dealAmount}} 
                    onClose={() => {
            setShowPrint(false);
           // window.location.reload(); 
           resetForm();
        }}
                />
            )}
        </div>
    );
};


// Styles remain mostly same, just added animation and refined finalGrid
const styles = {
    container: { padding: '20px' },
    stepper: { display: 'flex', gap: '10px', marginBottom: '20px' },
    step: { flex: 1, padding: '12px', background: '#e2e8f0', borderRadius: '10px', textAlign: 'center' },
    activeStep: { flex: 1, padding: '12px', background: '#2563eb', color: '#fff', borderRadius: '10px', textAlign: 'center', fontWeight: 'bold' },
    mainCard: { background: '#fff', padding: '30px', borderRadius: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' },
    input: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', marginBottom: '10px' },
    listItem: { padding: '12px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', transition: '0.2s' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px', marginTop: '15px' },
    bikeCard: { border: '1px solid #e2e8f0', padding: '15px', borderRadius: '12px', cursor: 'pointer' },
    detailBox: { background: '#f8fafc', padding: '15px', borderRadius: '12px', marginBottom: '15px', border: '1px solid #e2e8f0' },
    calcBox: { background: '#fff', border: '1px solid #2563eb', padding: '20px', borderRadius: '15px' },
    row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
    smallInput: { width: '120px', padding: '8px', borderRadius: '5px', border: '1px solid #cbd5e1' },
    submitBtn: { width: '100%', padding: '15px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', marginTop: '10px' },
    warnBox: { padding: '15px', background: '#fffbeb', color: '#92400e', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' },
    backBtn: { padding: '5px 15px', background: '#f1f5f9', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }
};

export default CommissionSale;